export const SatelliteIndexesMaster = {
  colormaps: [
    {
      index: 'ndvi',
      colors: ['#A50026', '#E3F39B', '#8FBF76', '#006837'],
      histogramColors: ['#D46E59', '#EBE764', '#E3FF66', '#006837'],
      start: -0.5,
      stop: 0.8,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['spacesense'],
    },
    {
      index: 'ndvi',
      colors: [
        '#87220F',
        '#9C4819',
        '#B47124',
        '#CB9B2D',
        '#DFC337',
        '#F3ED3F',
        '#D1D93A',
        '#A6BE31',
        '#7CA42B',
        '#508B23',
        '#29751E',
      ],
      histogramColors: [],
      start: -0.5,
      stop: 0.8,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['agrosat'],
    },
    {
      index: 'ndwi',
      colors: ['#7F2704', '#FCDEBE', '#83BBDB', '#08306B'],
      histogramColors: ['#c76f70', '#ffeedb', '#00a2ff', '#214f94'],
      start: -0.4,
      stop: 0.7,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['spacesense'],
    },
    {
      index: 'ndwi',
      colors: [
        '#810101',
        '#BB0200',
        '#F60001',
        '#FF8712',
        '#FFF203',
        '#B2FF92',
        '#3AFFF2',
        '#0F8AFF',
        '#160AFF',
        '#0F01C5',
        '#07008A',
      ],
      histogramColors: [],
      start: -0.4,
      stop: 0.7,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['agrosat'],
    },
    {
      index: 'yp',
      colors: [
        '#87220F',
        '#9C4819',
        '#B47124',
        '#CB9B2D',
        '#DFC337',
        '#F3ED3F',
        '#D1D93A',
        '#A6BE31',
        '#7CA42B',
        '#508B23',
        '#29751E',
      ],
      histogramColors: [],
      start: -0.5,
      stop: 0.8,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['agrosat'],
    },
    {
      index: 'chi',
      colors: ['#A50026', '#E3F39B', '#8FBF76', '#006837'],
      histogramColors: ['#D46E59', '#EBE764', '#E3FF66', '#006837'],
      start: 0.0,
      stop: 1.5,
      minVal: 0.0,
      maxVal: 10.0,
      providers: ['spacesense'],
    },
    {
      index: 'ndre',
      colors: ['#006837', '#8FBF76', '#E3F39B', '#A50026'],
      histogramColors: ['#006837', '#E3FF66', '#EBE764', '#D46E59'],
      start: -0.89,
      stop: 0.89,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['spacesense'],
    },
    {
      index: 'savi',
      colors: ['#A50026', '#E3F39B', '#8FBF76', '#006837'],
      histogramColors: ['#D46E59', '#EBE764', '#E3FF66', '#006837'],
      start: -0.89,
      stop: 1.1,
      minVal: 0.0,
      maxVal: 1.4,
      providers: ['spacesense'],
    },
    {
      index: 'lai',
      colors: ['#A50026', '#E3F39B', '#8FBF76', '#006837'],
      histogramColors: ['#D46E59', '#EBE764', '#E3FF66', '#006837'],
      start: -0.89,
      stop: 7.0,
      minVal: 0.0,
      maxVal: 6.0,
      providers: ['spacesense'],
    },
    {
      index: 'evi',
      colors: ['#A50026', '#E3F39B', '#8FBF76', '#006837'],
      histogramColors: ['#D46E59', '#EBE764', '#E3FF66', '#006837'],
      start: 0.0,
      stop: 4.0,
      minVal: 0.0,
      maxVal: 6.0,
      providers: ['spacesense'],
    },
    {
      index: 'rgb',
      colors: [],
      histogramColors: [],
      start: 0,
      stop: 0,
      minVal: 0.0,
      maxVal: 1.0,
      providers: ['spacesense', 'agrosat'],
    },
  ],
};
export const SatelliteIndexes = {
  colormaps: [],
};
